<button {...$$restProps}
        class="{$$restProps.class ?? ''} btn-close"
        aria-label={ariaLabel}
        on:click>
  X
</button>

<script >export let ariaLabel = 'close';
</script>

<style >button {
  float: right;
  border: 0;
  padding: 0;
  background: none;
  box-shadow: none;
  transform: none;
}
button:hover, button:focus {
  transform: none;
  box-shadow: none;
  border: 0;
}</style>
